<template>
    <h2 class="text-regular font-medium lg:text-4xl lg:leading-[3.5rem]">
        {{ $t("testfleet.overview.intro.title") }} {{ " " }}
        <span v-if="company_name">
            {{ $t("testfleet.overview.intro.for") }}
            <span class="text-primary">
                {{ company_name }}
            </span>
        </span>
    </h2>

</template>
<script setup lang="ts">

const { company_name } = defineProps(['company_name']);
</script>